import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogComponent } from '@bca-core/modules/dialog/dialog/dialog.component';
import { DialogService } from '@bca-core/modules/dialog/services/dialog.service';

const dialogs = [DialogComponent];

@NgModule({
  imports: [CommonModule],
  declarations: [...dialogs],
  providers: [DialogService],
  exports: [...dialogs],
})
export class DialogModule {}
